import { maybeGetProjectUpdateAriFromUrlUpdateId } from '@townsquare/project-update-card/ari-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router/types';

import ProjectUpdateComposerEmbedQuery, {
	type ProjectUpdateComposerEmbedQuery as ProjectUpdateComposerEmbedQueryType,
} from '../components/ProjectUpdateComposerEmbed/__generated__/ProjectUpdateComposerEmbedQuery.graphql';

export const projectUpdateComposerEmbedResource = createRelayResource<ProjectUpdateComposerEmbedQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const projectKey = routerContext.match.params.projectKey;

		const context = resourceContext as ResourceContext;
		const updateId = maybeGetProjectUpdateAriFromUrlUpdateId(routerContext.query.updateId, context.workspace?.cloudId);

		return {
			query: ProjectUpdateComposerEmbedQuery,
			variables: {
				key: projectKey ?? '',
				updateId: updateId ?? '',
				isExistingUpdate: !!updateId,
			},
		};
	},
});
